import {resolveBannerSelection, resolveOfferedBannerSelection} from "../data/template-availability";
import {hasGridBackgroundGallery} from "./default-resources";
import {type DefaultResources} from "./defaults";
import {patchBanner, type BannerInstance} from "./document";
import {bannerFromLegacyScene} from "./legacy";
import {createPresetBackgroundPatch} from "./background";

// A format belongs to the banner's current channel/product/content type/set.
// Materialize only format-dependent data; saved content and custom assets win.
export async function changeBannerFormat(banner: BannerInstance, templateKey: string, resources: DefaultResources): Promise<BannerInstance> {
  const current = resolveBannerSelection(banner);
  const target = resolveOfferedBannerSelection({...banner, templateKey});
  if (target.definition.channel !== current.definition.channel) throw new Error("Choose a format from the banner's current channel");
  if (templateKey === banner.templateKey) return structuredClone(banner);
  const layout = target.layouts.includes(banner.appearance.layout) ? banner.appearance.layout : target.layouts[0];
  const defaults = bannerFromLegacyScene({...banner, templateKey, layout}, {});
  let next: BannerInstance = {...structuredClone(banner), templateKey,
    appearance: {...banner.appearance, layout},
    assets: {...banner.assets, slots: {...defaults.assets.slots, ...banner.assets.slots}}};
  if (/^[1-9][0-9]*$/.test(banner.appearance.backgroundOption) && hasGridBackgroundGallery(next)) {
    next = patchBanner(next, await createPresetBackgroundPatch(next, banner.appearance.backgroundOption, resources));
  }
  // Also validates custom/generative invariants when no gallery is involved.
  return patchBanner(next, {});
}
